class HomeModel {}

export default HomeModel;
